import React, { useState, useEffect, Component } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import TableView from "../TableView";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Tax = () => {
  const storedToken = Cookies.get("authToken");
  const storedUser = Cookies.get("authUser");
  const [authtoken, setAuthToken] = useState(storedToken || "");
  const [authUser, setAuthUser] = useState(storedUser || "");
  const [baseUrl, setBaseUrl] = useState("https://devmol.evolve-demo.com/api/");
  const [pageComponent, setPageComponent] = useState("taxes");
  const [data, setData] = useState(undefined);
  const [tax, setTax] = useState("");
  const [taxRate, setTaxRate] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [Active, setActive] = useState("");
  const [btnActive, setBtnActive] = useState(true);
  const [selectRowData, setSelectRowData] = useState("");
  const [emptyTaxCode, setEmptyTaxCode] = useState(false);
  const [emptyTaxvalue, setEmptyTaxvalue] = useState(false);
  const [emptyInput, setEmptyInput] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const createNewRow = () => {
    setBtnActive(false);
    setSelectRowData("");
    setTax("");
    setTaxRate("");
  };

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/all`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setData(data.taxes);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  function setSelectedRow(rowid) {
    axios
      .get(`${baseUrl}${pageComponent}/single/${rowid}`, {
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      })
      .then((res) => {
        const selectRowData = res.data;
        console.log(selectRowData);
        setSelectRowData(selectRowData);
        setTax(selectRowData.tax.tax ? selectRowData.tax.tax : "");
        setTaxRate(
          selectRowData.tax.tax_rate ? selectRowData.tax.tax_rate : ""
        );
        if (
          selectRowData.tax.active_status
            ? selectRowData.tax.active_status == 1
            : ""
        ) {
          setIsChecked(true);
        } else {
          setIsChecked(false);
        }
        setBtnActive(false);
      });
  }

  const handleSave = (event) => {
    event.preventDefault();

    if (tax.length == 0) {
      toast.error("Tax Code can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyTaxCode(true);
      setEmptyInput(true);
    } else {
      setEmptyTaxCode(false);
    }

    if (taxRate.length == 0) {
      toast.error("Tax Name can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyTaxvalue(true);
      setEmptyInput(true);
    } else {
      setEmptyTaxvalue(false);
    }

    if (emptyInput !== true) {
      const inputData = {
        tax: tax,
        tax_rate: taxRate,
        active_status: isChecked ? 1 : 0,
      };
      axios
        .post(`${baseUrl}${pageComponent}/store`, inputData, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${authtoken}`,
          },
        })
        .then((response) => {
          toast.success("Successfully Save Data ! ", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setTimeout(window.location.reload.bind(window.location), 2000);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
    }
  };

  const edditRow = (event) => {
    event.preventDefault();
    if (selectRowData !== "") {
      const inputData = {
        tax: tax,
        tax_rate: taxRate,
        active_status: isChecked ? 1 : 0,
      };
      axios
        .post(
          `${baseUrl}${pageComponent}/update/${selectRowData.tax.id}`,
          inputData,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authtoken}`,
            },
          }
        )
        .then((response) => {
          console.log(response.data);
          window.location.reload(false);
          alert("Successfully Save Data");
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      toast.error("Please Select data Row", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const deleteRow = (event) => {
    event.preventDefault();
    axios.delete(`${baseUrl}${pageComponent}/destroy/${selectRowData.tax.id}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    });
    toast.warning("Successfully Deleted Data Row", {
      position: toast.POSITION.TOP_RIGHT,
    });
    setTimeout(window.location.reload.bind(window.location), 2000);
  };

  const tTitle = ["Tax", "Tax Rate", "Active"];
  const columns = ["tax", "tax_rate", "active_status"];
  return (
    <Container>
      <ToastContainer autoClose={2000} />
      <Row>
        <Col>
          <Form className="mt-4 bottom-border pb-3">
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Tax Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="NBT"
                    value={tax}
                    className={emptyTaxCode == true ? "border-red2" : ""}
                    onChange={(e) => setTax(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Percentage</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="0.0000"
                    value={taxRate}
                    className={emptyTaxvalue == true ? "border-red2" : ""}
                    onChange={(e) => setTaxRate(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3 " controlId="formBasicCheckbox">
              <Form.Check
                type="checkbox"
                label="Active"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
            </Form.Group>
            <Row className="text-center">
              <Col className="text-end">
                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={selectRowData !== "" ? edditRow : handleSave}
                  disabled={btnActive}
                >
                  Save
                </Button>

                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={createNewRow}
                >
                  New
                </Button>

                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={edditRow}
                  disabled={btnActive}
                >
                  Update
                </Button>
                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={deleteRow}
                  disabled={btnActive}
                >
                  Delete
                </Button>

                <Button className="ms-3" variant="primary" disabled={btnActive}>
                  Print
                </Button>

                <Button className="ms-3" variant="primary" type="submit">
                  Cancel
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <TableView
            data={data}
            columns={columns}
            tTitle={tTitle}
            setSelectedRow={setSelectedRow}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Tax;
